import React from 'react';
// Data
import { galleryImagesArray } from '../../utils/data/GalleryData';
// Components
import CallToActionOne from '../cta/CallToActionOne';
import VisitMyPaySites from '../general/VisitMyPaySites';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';

function GalleryPageMainContainer() {
  return (
    <main role='main' className='pt-16 grid'>
      <div className='grid container mx-auto w-full h-full justify-center items-center py-2 px-6 md:px-12 overflow-hidden'>
        <section className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-8 lg:gap-y-16 lg:gap-x-12 gap-x-4'>
          {galleryImagesArray.map((image, index) => (
            <div
              key={index}
              className='flex gap-2 lg:gap-4 flex-col items-center'
            >
              {/* Image with Zoom Effect on Hover */}
              <div className='w-full h-full max-h-[80vh] overflow-hidden rounded-lg neon_shadow_thin group'>
                <img
                  src={image.src}
                  alt={image.alt}
                  className='w-full h-full object-cover rounded-lg transition-transform duration-[5s] group-hover:scale-125'
                  loading='lazy'
                />
              </div>
            </div>
          ))}
        </section>
      </div>

      {/* Cta */}
      <div className='py-4'>
        <CallToActionOne />
      </div>

      {/* Paysites */}
      <div className='mt-8 pb-12'>
        <VisitMyPaySites />
      </div>

      {/* Social cta */}
      <SocialMediaCtaComponent />
    </main>
  );
}

export default GalleryPageMainContainer;
